const config = {
    index: {
        'bigData-btn-refresh': '首页,,,全局刷新',
        'bigData-btn-config': '首页,,,配置',
        'bigData-btn-config-ok': '首页,添加展示模块,,确定',
        'bigData-btn-config-cancel': '首页,添加展示模块,,取消',
        'bigData-btn-config-reset': '首页,添加展示模块,,重置',
        'bigData-btn-add': '首页,,,添加模块',
        'bigData-btn-all-notice': '首页,,,全部公告',
        'bigData-btn-detail-notice': '首页,,,公告详情',

        'bigData-tabs-pendingTender': '首页,已报名待购标书,,',
        'bigData-tabs-bidPaid': '首页,待缴纳投标保证金,,',
        'bigData-tabs-sealedQuotation': '首页,待盖章应标文件,,',
        'bigData-tabs-toQuote': '首页,待报价,,',
        'bigData-tabs-pendingContractSigning': '首页,待签署合同,,',

        'bigData-tabs-view-pendingTender': '首页,,,已报名待购标书',
        'bigData-tabs-view-bidPaid': '首页,,,待缴纳投标保证金',
        'bigData-tabs-view-sealedQuotation': '首页,,,待盖章应标文件',
        'bigData-tabs-view-toQuote': '首页,,,待报价',
        'bigData-tabs-view-pendingContractSigning': '首页,,,待签署合同',

        'bigData-btn-view-pendingTender': '首页,已报名待购标书,,去查看',
        'bigData-btn-view-bidPaid': '首页,待缴纳投标保证金,,去查看',
        'bigData-btn-view-sealedQuotation': '首页,待盖章应标文件,,去查看',
        'bigData-btn-view-toQuote': '首页,待报价,,去查看',
        'bigData-btn-view-pendingContractSigning': '首页,签署合同,,去查看',

        'bigData-btn-todo-supplierJoinApplyCount': '首页,运力待办,,查看司机加入申请',
        'bigData-btn-todo-supplierDelegateCount': '首页,运力待办,,查看司机委派函',
        'bigData-btn-todo-waitSupplierConfirmCount': '首页,绩效待办,,查看月度绩效',
    },
    storeWorkbench: {
        'bigData-btn-cw': '仓储工作台,,,预警待办-合同预警',
        'bigData-btn-qw': '仓储工作台,,,预警待办-资质预警',
        'bigData-btn-sw': '仓储工作台,,,预警待办-工人发薪预警',
        'bigData-btn-d-st': '仓储工作台,,,仓储委派函-委派函待发起数',
        'bigData-btn-d-sg': '仓储工作台,,,仓储委派函-待签订委派函数',
        'bigData-btn-d-ad': '仓储工作台,,,仓储委派函-委派函待审批数',
        'bigData-btn-p-ad': '仓储工作台,,,绩效整改-整改',
        'bigData-btn-p-ta': '仓储工作台,,,绩效整改-整改约谈',
        'bigData-btn-p-rs': '仓储工作台,,,绩效整改-运作风险',
        'bigData-btn-b-fe': '仓储工作台,,,财务待办-费用核对',
        'bigData-btn-b-bi': '仓储工作台,,,财务待办-账单核对',
        'bigData-btn-b-ap': '仓储工作台,,,财务待办-结算申请',
        'bigData-btn-b-ti': '仓储工作台,,,财务待办-发票管理',
        'bigData-btn-b-cg': '仓储工作台,,,财务待办-往来对账单',
        'bigData-btn-b-nt': '仓储工作台,,,财务待办-无欠税证明',
        'bigData-btn-tn-vi': '仓储工作台,,,招标公告-去查看',
        'bigData-btn-td-vi': '仓储工作台,,,招标待办-去查看',
        'bigData-btn-sc-vi': '仓储工作台,,,待签署合同-去查看',
        'bigData-btn-cd-vi': '仓储工作台,,,待支付合同押金-去查看',
    },
}
export default config
